import { Box } from '@mui/material';
import { isAprilFoolsDay } from '../utils/aprilFools';

const RecipeImage = ({ src, alt, sx, ...props }) => (
    <Box
        component="img"
        src={isAprilFoolsDay() ? '/anchovie.jpg' : (src || '/anchovie.jpg')}
        alt={alt}
        onError={(e) => { e.target.onerror = null; e.target.src = '/image-error.svg'; }}
        sx={sx}
        {...props}
    />
);

export default RecipeImage;
